import { createContext, useContext, useState, useEffect } from 'react'

const TemaContext = createContext()

export const TemaProvider = ({ children }) => {
  const [oscuro, setOscuro] = useState(() => {
    const guardado = localStorage.getItem('dayflow-tema')
    if (guardado) return guardado === 'oscuro'
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches || false
  })

  useEffect(() => {
    const root = document.documentElement
    if (oscuro) {
      root.classList.add('dark')
      localStorage.setItem('dayflow-tema', 'oscuro')
    } else {
      root.classList.remove('dark')
      localStorage.setItem('dayflow-tema', 'claro')
    }
  }, [oscuro])

  return (
    <TemaContext.Provider value={{ oscuro, setOscuro }}>
      {children}
    </TemaContext.Provider>
  )
}

export const useTema = () => useContext(TemaContext)
